// Medallia survey IDs

export const PDP_WITH_AI_DESCRIPTION = 36574;
export const PDP_WITHOUT_AI_DESCRIPTION = 36528;
